import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

interface StudentDetailsConfigOptions {}

export const getStudentDetailsConfig = (options: StudentDetailsConfigOptions = {}): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			title: 'Student profiles',
			subtitle:
				'Student profiles allow you to manage book assignments for them. You can assign new books, view student progress for each book and track their progress.\n\nYou can also view reading completion status, activity scores and student ratings for each book. ',
			image: '/img/ftux-student-details-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-details-view',
			subtitle: 'Find student login details here.',
			tooltipPlacement: 'right' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-menu',
			subtitle:
				'Click here for additional actions such as transferring the student to a different class or archiving them.',
			tooltipPlacement: 'right' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-tab',
			subtitle:
				'Assigned books are organised by Stage. Select a tab to view a particular stage. If a tab is greyed out, there are no books assigned to the student for that stage.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#stage-books-0',
			subtitle:
				"You will be able to view students' progress for a book, including their completion status, activity score, and student rating.",
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#stage-books-arrow',
			subtitle: 'Click the arrow to view the activity questions and student results for a book',
			tooltipPlacement: 'top' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#manage-book-button',
			subtitle: 'Click here to manage book assignments for the student.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'student-details-ftux',
		name: 'Student Details Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
